(function () {
  "use strict";

  var map;
  var bounds;
  var caixa;
  var markers = {};
  let locais = [];

  const iconeMc = url_base + "app/assets/dist/img/maps/marker.png";
  const iconeMcHover = url_base + "app/assets/dist/img/maps/marker_hover.png";
  const clusterImg = url_base + "app/assets/dist/img/maps/m";
  //const clusterImg = 'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m';

  // Obtém os imóveis e suas coordenadas
  function getLocais() {
    $(".bloco-anuncio.bloco-pg").each(function () {
      locais.push({
        id: $(this).data("id"),
        url: $(this).attr("href"),
        lat: Number($(this).data("lat")),
        lng: Number($(this).data("lng")),
        img: $(this).data("img"),
        titulo: $(this).data("titulo"),
        cidade: $(this).data("cidade"),
      });
    });
  }

  // Popula os locais no mapa
  function populaLocais() {
    getLocais();
    if (locais.length > 0) {
      bounds = new google.maps.LatLngBounds();
      locais.forEach(function (local) {
        var position = {
          lat: local.lat,
          lng: local.lng,
        };
        bounds.extend(position);
        var marker = new google.maps.Marker({
          map: map,
          animation: google.maps.Animation.DROP,
          position: position,
          icon: { url: iconeMc, scaledSize: new google.maps.Size(35, 35) },
        });
        marker.addListener("click", function () {
          caixa.setContent(`
            <a href="${local.url}" class="map-popup">
              <figure>
                <img src="${local.img}" alt="${local.titulo}">
              </figure>
              <div class="map-popup-infos">
                <div class="map-popup-inner">
                  <div class="map-popup-titulo">${local.titulo}</div>
                  <div class="map-popup-cidade">${local.cidade}</div>
                </div>
              </div>
            </a>`);
          caixa.open(map, marker);
        });
        markers[local.id] = marker;
      });
      if (locais.length > 1) {
        map.fitBounds(bounds);
      } else {
        map.setCenter(bounds.getCenter());
        map.setZoom(15);
      }

      var markerCluster = new MarkerClusterer(map, markers, {
        imagePath: clusterImg,
      });

      $(".bloco-anuncio.bloco-pg")
        .on("mouseover", function () {
          markers[$(this).data("id")].setIcon({
            url: iconeMcHover,
            scaledSize: new google.maps.Size(35, 35),
          });
        })
        .on("mouseout", function () {
          markers[$(this).data("id")].setIcon({
            url: iconeMc,
            scaledSize: new google.maps.Size(35, 35),
          });
        });
    }
  }

  // Inicializa o mapa da tela
  function initMap() {
    map = new google.maps.Map(document.getElementById("mapa-anuncios"), {
      mapTypeControl: false,
      streetViewControl: false,
    });
    caixa = new google.maps.InfoWindow();
    google.maps.event.addListener(map, "click", function () {
      caixa.close();
    });
    populaLocais();
  }

  $(window).load(function () {
    if ($("#mapa-anuncios").length > 0) {
      initMap();
    }
  });
})();
